import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Modal from 'react-modal';
import App from './App';
// Axios
import axios from 'axios';
// Sentry
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/browser';
// WebVitals
import reportWebVitals from './reportWebVitals';
// Language management
import './i18n';
// Styles
import './index.css';

// ✅ Version gate
import { APP_VERSION } from './appVersion';
import { enforceAppVersion } from './versionGate';

const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

axios.defaults.baseURL =
	ENVIRONMENT === 'PRODUCTION'
		? 'https://olib-api.aquinasnetwork.com'
		: 'https://olib-api.aquinasnetwork.com';
// : 'http://localhost:8000';

if (ENVIRONMENT === 'PRODUCTION') {
	Sentry.init({
		dsn: process.env.REACT_APP_SENTRY_CONFIG,
		integrations: [new BrowserTracing()],
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
	});
}

Modal.setAppElement('#root');

function getToken() {
	try {
		return localStorage.getItem('token');
	} catch (e) {
		return null;
	}
}

async function bootstrap() {
	await enforceAppVersion(APP_VERSION);

	const token = getToken();
	const currentPath = window.location.pathname || '';
	const isGalePath = /(^|\/)gale(\/|$)/i.test(currentPath);

	if (!token && currentPath !== '/' && !isGalePath) {
		window.location.replace('/');
		return;
	}

	const root = ReactDOM.createRoot(document.getElementById('root'));
	root.render(
		<React.StrictMode>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</React.StrictMode>,
	);

	reportWebVitals();
}

bootstrap();
